import { parseRuntimeConfig, type RuntimeConfig } from './runtime-schema';

let configuration: RuntimeConfig | undefined;
let loading: Promise<void> | undefined;

export const initializeRuntimeConfig = (value: unknown): void => {
  if (configuration) {
    throw new Error('Runtime configuration is already initialized');
  }
  configuration = parseRuntimeConfig(value);
};

export const getRuntimeConfig = (): RuntimeConfig => {
  if (!configuration) {
    throw new Error('Runtime configuration has not been initialized');
  }
  return configuration;
};

const fetchRuntimeConfig = async (basePath: string): Promise<void> => {
  const response = await fetch(`${basePath}config.json`, {
    cache: 'no-store',
    signal: AbortSignal.timeout(10000),
  });
  if (
    !response.ok ||
    response.headers.get('content-type')?.split(';')[0]?.trim() !==
      'application/json'
  ) {
    throw new Error('Runtime configuration could not be loaded');
  }
  const value: unknown = await response.json();
  initializeRuntimeConfig(value);
};

export const loadRuntimeConfig = (basePath: string): Promise<void> => {
  if (configuration) {
    return Promise.resolve();
  }
  loading ??= fetchRuntimeConfig(basePath).catch((error: unknown) => {
    // A failed request must not prevent the operator from trying again.
    loading = undefined;
    throw error;
  });
  return loading;
};
